import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  reservationCalendarTimeSlotsResponseSchema,
  type ReservationCalendarTimeSlotsResponse,
} from '../../../common/validations/reservationCalendarSchemas'

import { get } from 'api/apiClient'

export const reservationCalendarTimeSlotsKey = (
  contractUuid: string,
  calendarId: string,
  startDate: string,
  endDate: string
) => {
  const baseKey = `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/reservation-calendars/${calendarId}/time-slots`
  return [baseKey, startDate, endDate] as const
}

export const buildReservationCalendarTimeSlotsPath = (
  contractUuid: string,
  calendarId: string,
  startDate: string,
  endDate: string
) => {
  const basePath = API_ENDPOINTS.RESERVATION_CALENDAR_TIME_SLOTS.replace(
    ':contractUuid',
    contractUuid
  ).replace(':calendarId', calendarId)
  return `${basePath}?startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}`
}

const params = (
  contractUuid: string,
  calendarId: string,
  startDate: string,
  endDate: string
) => ({
  queryKey: reservationCalendarTimeSlotsKey(
    contractUuid,
    calendarId,
    startDate,
    endDate
  ),
  queryFn: () =>
    get<ReservationCalendarTimeSlotsResponse>(
      buildReservationCalendarTimeSlotsPath(
        contractUuid,
        calendarId,
        startDate,
        endDate
      ),
      reservationCalendarTimeSlotsResponseSchema
    ),
  staleTime: 0,
})

export const useAPIGetReservationCalendarTimeSlots = (
  contractUuid: string,
  calendarId: string,
  startDate: string,
  endDate: string,
  options?: { enabled?: boolean }
) =>
  useQuery<ReservationCalendarTimeSlotsResponse>({
    ...params(contractUuid, calendarId, startDate, endDate),
    enabled: options?.enabled,
  })

export const useAPIGetReservationCalendarTimeSlotsSuspense = (
  contractUuid: string,
  calendarId: string,
  startDate: string,
  endDate: string
) =>
  useSuspenseQuery<ReservationCalendarTimeSlotsResponse>(
    params(contractUuid, calendarId, startDate, endDate)
  )
